/**
 * Shared document expiry utilities used across dashboards and document management.
 */

/**
 * Returns the number of days until a document expires.
 * Negative = already expired.
 */
export const getDaysUntilExpiry = (expiryDate) => {
  if (!expiryDate) return null;
  const today = new Date();
  today?.setHours(0, 0, 0, 0);
  const expiry = new Date(expiryDate);
  if (isNaN(expiry?.getTime())) return null;
  const diffMs = expiry - today;
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};

/**
 * Returns a status string for a document based on its expiry date.
 * 'expired' | 'expiring-critical' (≤14 days) | 'expiring-soon' (≤30 days) | 'valid' | 'no-expiry'
 */
export const getDocumentStatus = (expiryDate) => {
  const days = getDaysUntilExpiry(expiryDate);
  if (days === null) return 'no-expiry';
  if (days < 0) return 'expired';
  if (days <= 14) return 'expiring-critical';
  if (days <= 30) return 'expiring-soon';
  return 'valid';
};

/**
 * Returns true if a document needs attention (expired or expiring within 30 days).
 */
export const needsAttention = (expiryDate) => {
  const status = getDocumentStatus(expiryDate);
  return status === 'expired' || status === 'expiring-critical' || status === 'expiring-soon';
};
